import { Coupon } from '@petplate/schema';
import isEmpty from 'lodash/isEmpty';
import { createContext, useContext } from 'react';

export interface DiscountProviderProps {
  siteWideCoupons?: Partial<Coupon>[];
  subCancelledEntreesDiscount?: Partial<Coupon>;
  treatsDiscount?: Partial<Coupon>;
  loading: boolean;
}

export const DiscountContext = createContext<DiscountProviderProps>({
  siteWideCoupons: [],
  subCancelledEntreesDiscount: undefined,
  treatsDiscount: undefined,
  loading: false
});

export const useSiteWideDiscount = (): DiscountProviderProps => {
  const context = useContext(DiscountContext);

  if (isEmpty(context)) {
    throw new Error('Called useSiteWideDiscount before setting DiscountProvider context');
  }
  return context;
};
